import { Instagram, Youtube, MessageCircle } from 'lucide-react';
import { BRAND } from '@/lib/data';
import { Logo } from './Logo';

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-ink border-t border-white/5 pt-20 pb-10 overflow-hidden"
        >
            <div className="absolute inset-x-0 top-0 overflow-hidden border-b border-white/5">
                <div className="flex whitespace-nowrap animate-marquee">
                    {Array.from({ length: 4 }).map((_, i) => (
                        <span
                            key={i}
                            className="font-serif italic text-bone-dim/10 text-[18vw] leading-[0.9] tracking-tighter pr-12"
                        >
                            Love, directed.
                        </span>
                    ))}
                </div>
            </div>

            <div className="relative px-6 md:px-12 lg:px-16 grid grid-cols-1 md:grid-cols-12 gap-10 pt-[12vw]">
                <div className="md:col-span-5">
                    <Logo className="h-10 w-10 text-bone" />
                    <p className="mt-5 text-bone-dim max-w-sm text-sm font-light leading-relaxed">
                        A cinematic studio directing weddings, brand films, and editorial
                        photography. Available worldwide on request.
                    </p>
                </div>

                <div className="md:col-span-3">
                    <p className="text-[10px] uppercase tracking-[0.3em] text-bone-dim mb-4">
                        Studio
                    </p>
                    <ul className="space-y-2 text-bone text-sm font-light">
                        <li>{BRAND.phone}</li>
                        <li className="break-all">{BRAND.email}</li>
                        <li>Hyderabad · India</li>
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <p className="text-[10px] uppercase tracking-[0.3em] text-bone-dim mb-4">
                        Follow the cut
                    </p>
                    <div className="flex gap-3">
                        <SocialLink href={BRAND.instagram} icon={<Instagram size={16} />} label="Instagram" testid="footer-instagram" />
                        <SocialLink href={BRAND.youtube} icon={<Youtube size={16} />} label="YouTube" testid="footer-youtube" />
                        <SocialLink href={BRAND.whatsapp} icon={<MessageCircle size={16} />} label="WhatsApp" testid="footer-whatsapp" />
                    </div>
                </div>
            </div>

            <div className="relative px-6 md:px-12 lg:px-16 mt-16 pt-6 border-t border-white/5 flex flex-col md:flex-row justify-between gap-3 text-[10px] uppercase tracking-[0.3em] text-bone-dim">
                <p>© {new Date().getFullYear()} Bros On Board · All Rights Reserved</p>
                <p>Directed in 24 frames a second.</p>
            </div>
        </footer>
    );
};

const SocialLink = ({ href, icon, label, testid }) => (
    <a
        href={href}
        target="_blank"
        rel="noreferrer"
        data-testid={testid}
        aria-label={label}
        className="w-11 h-11 border border-white/15 flex items-center justify-center text-bone hover:border-gold hover:text-gold transition-colors duration-300"
    >
        {icon}
    </a>
);
